import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@monksflow/monks-ui';
import {
  BarChart3Icon,
  ChevronDownIcon,
  MessageSquareIcon,
  PlusIcon,
  UsersIcon,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface StartNewMenuProps {
  /** Offered only where it is built; omitted entries leave the menu. */
  onChat?: () => void;
  /**
   * Why chatting is not possible yet, shown under the greyed entry. Chat is offered when
   * this is absent - an audience nobody has saved has no persona to talk to.
   */
  chatUnavailableReason?: string;
  onFocusGroup?: () => void;
  onContentTest?: () => void;
}

/**
 * The things that can be started from an audience: a chat with it, and later a focus group or
 * a content test against it. Each is offered only where the surface passes a handler for it.
 */
export const StartNewMenu = ({
  onChat,
  chatUnavailableReason,
  onFocusGroup,
  onContentTest,
}: StartNewMenuProps) => {
  const { t } = useTranslation('analysis');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button>
          <PlusIcon />
          {t('analysisResult.iqpersonaDetail.startNew')}
          <ChevronDownIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {onChat && (
          <>
            <DropdownMenuItem disabled={Boolean(chatUnavailableReason)} onSelect={onChat}>
              <MessageSquareIcon />
              {t('analysisResult.iqpersonaDetail.chat')}
            </DropdownMenuItem>
            {chatUnavailableReason && (
              <DropdownMenuLabel>{chatUnavailableReason}</DropdownMenuLabel>
            )}
          </>
        )}
        {onFocusGroup && (
          <DropdownMenuItem onSelect={onFocusGroup}>
            <UsersIcon />
            {t('analysisResult.iqpersonaDetail.focusGroup')}
          </DropdownMenuItem>
        )}
        {onContentTest && (
          <DropdownMenuItem onSelect={onContentTest}>
            <BarChart3Icon />
            {t('analysisResult.iqpersonaDetail.contentTest')}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
